import { z } from 'zod'

import { classStatuses } from '../class-form/class'

/** Where the attendance searches live. */
export const findAttendancePath = '/classes/attendance'
export const findMeetingJoinsPath = '/classes/meeting-joins'

/** The API's lists. */
export const attendanceSearchApi = '/classes/v1/attendance'
export const meetingJoinsApi = '/classes/v1/meeting-joins'

/** An enrollment's statuses, as Entitlements names them. */
export const enrollmentStatuses = ['requested', 'waitlisted', 'enrolled', 'denied', 'canceled'] as const

/** A class enrollment's completion statuses (CLS-11). */
export const completionStatuses = ['notRecorded', 'attending', 'complete', 'incomplete', 'noShow', 'failed'] as const

const names = { firstName: z.string(), lastName: z.string(), displayName: z.string() }

const classColumns = {
  classId: z.string(),
  className: z.string(),
  classOrganizationId: z.string(),
  classOrganizationName: z.string().nullish(),
  classStatus: z.enum(classStatuses),
  timeZone: z.string(),
  sessionId: z.string(),
}

const attendanceSchema = z.object({
  enrollmentId: z.string(),
  userProfileId: z.string(),
  ...names,
  studentOrganizationName: z.string().nullish(),
  ...classColumns,
  sessionStartsOn: z.string(),
  sessionEndsOn: z.string(),
  enrollmentStatus: z.enum(enrollmentStatuses),
  completionStatus: z.enum(completionStatuses),
  attended: z.boolean(),
  checkedInOn: z.string().nullish(),
})

/** A student at one session of their class, as Find Class Attendance lists them. */
export type AttendanceRecord = z.infer<typeof attendanceSchema>

export function parseAttendanceRecord(item: unknown): AttendanceRecord {
  return attendanceSchema.parse(item)
}

const joinSchema = z.object({
  id: z.string(),
  joinedOn: z.string(),
  userProfileId: z.string(),
  ...names,
  personOrganizationName: z.string().nullish(),
  ...classColumns,
  sessionStartsOn: z.string().nullish(),
  sessionEndsOn: z.string().nullish(),
})

/** One join of a class's meeting, as Find Meeting Joins lists it. */
export type MeetingJoin = z.infer<typeof joinSchema>

export function parseMeetingJoin(item: unknown): MeetingJoin {
  return joinSchema.parse(item)
}
